import api from '@functions/api'

import type { AppDispatch } from '@redux/store'
import type {
  Action, EntityOptions, Errors,
} from '@redux/modules/types'

import { FlipperSettingModel } from '@models/types'

import { handleError } from '../utils'

const FETCH_REQUEST = 'realbase/flipperSetting/FETCH_REQUEST'
const FETCH_SUCCESS = 'realbase/flipperSetting/FETCH_SUCCESS'
const FETCH_FAILURE = 'realbase/flipperSetting/FETCH_FAILURE'

type FlipperSettings = { [key: string]: FlipperSettingModel }

export type FlipperSettingModuleState = {
  errors: string[],
  loaded: boolean,
  loading: boolean,
  result: FlipperSettings,
}

// Initial State
const initialState: FlipperSettingModuleState = {
  errors: [],
  loaded: false,
  loading: false,
  result: {},
}

// Actions
export function fetchRequest() {
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(payload: Partial<FlipperSettingModel> = {}) {
  return {
    type: FETCH_SUCCESS,
    payload,
  }
}

export function fetchFailure(errors: Errors = []) {
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

// Action Creators
export function loadFlipperSettings(options: EntityOptions = {}) {
  return (dispatch: AppDispatch) => {
    // Set Loading
    dispatch(fetchRequest())

    const promise = api('/systems/flipper_settings.json', options)
      .then(({ data }: { data: FlipperSettingModel[] }) => {
        const updatedData = data.reduce((acc: FlipperSettings, item) => {
          acc[item.name] = item
          return acc
        }, {})

        dispatch(fetchSuccess(updatedData))

        return { success: true as const, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(fetchFailure(errors))

        return { success: false as const, errors }
      })

    return promise
  }
}

// Reducer
export default function reducer(
  state: FlipperSettingModuleState = initialState,
  action: Action = { type: '' },
): FlipperSettingModuleState {
  switch (action.type){
    case FETCH_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        errors: [],
        result: action.payload,
      }
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        errors: action.errors || [],
      }
    default:
      return state
  }
}
